export default __webpack_public_path__ + "static/media/lease-analytics.7ab61c30.png";